.errorMessageDiv {
  display: flex;
  flex-direction: row;
  height: auto;
  max-height: 100%;
  background-color: #f8dedd;
  border-radius: 7px;
}

.errorMessageDiv .errorMessage {
  font-size: 0.95rem;
  color: #d24625;
  margin-top: 0.5%;
  margin-bottom: -2px;
  padding: 5px;
}

.apiErrorMessageDiv {
  display: flex;
  flex-direction: row;
  height: auto;
  max-height: 100%;
  background-color: #f8dedd;
  border-radius: 7px;
}

.apiErrorMessageDiv .apiErrorMessage {
  font-size: 0.95rem;
  color: #d24625;
  margin-top: 2%;
  padding: 0;
  vertical-align: auto;
}
